import styled from '@emotion/styled'

export const MaterialSvgStyled = styled.svg({
  display: 'inline-block',
  fill: 'currentcolor',
  height: '1.4rem',
  width: '1.4rem',
})
